import ChevronDownIcon from "@components/icons/ChevronDownIcon";
import ChevronUpIcon from "@components/icons/ChevronUpIcon";
import ConfigurationsIcon from "@components/icons/ConfigurationsIcon";
import RebootIcon from "@components/icons/RebootIcon";
import { Accordion } from "flowbite-react";
import Button from "./Button";

const CustomAccordion = ({
	title,
	children,
	classCss,
	isOpen,
	toggleAccordion,
	showButton = false,
	showButtonSetup = false,
	onNewConfiguration = null,
	onActivateSetup = null,
	rebootStarlink = null,
	customButton = null,
	canViewActivationProv = false,
	canRebootTerminal = false,
	isMobile,
	showviewvoucher = false,
	customviewVouchersButton = null,
	backroundClass = false,
}) => {
	return (
		<Accordion className={`dark border-0 ${classCss ? classCss : ""}`}>
			<Accordion.Panel className="bg-navbar-bg">
				<Accordion.Title
					className="!bg-navbar-bg custom-accordion-title flex w-full cursor-pointer flex-col flex-wrap justify-between gap-2 border-[#272B49] border-b-2 border-solid p-3 sm:items-center sm:justify-between"
					onClick={toggleAccordion}
				>
					<div className="mr-1 flex flex-col sm:flex-row sm:items-center">
						<span className="border-0 text-start font-bold text-base text-white first:rounded-t-lg last:rounded-b-lg md:text-base">
							{title}
						</span>
					</div>
					{!isMobile && (
						<div className="flex sm:items-end">
							<div className="flex">
								{" "}
								<>
									{showButton &&
										(customButton || (
											<Button
												text="New Configuration"
												onClick={(e) => {
													e.stopPropagation();
													onNewConfiguration();
												}}
												color="blue"
												icon={ConfigurationsIcon}
											/>
										))}
								</>
								{showButtonSetup && (
									<>
										{canRebootTerminal && (
											<Button
												text="Reboot Terminal"
												onClick={(e) => {
													e.stopPropagation();
													rebootStarlink();
												}}
												icon={RebootIcon}
											/>
										)}
										{canViewActivationProv && (
											<Button
												text="Configuration setup"
												onClick={(e) => {
													e.stopPropagation();
													onActivateSetup();
												}}
												icon={ConfigurationsIcon}
											/>
										)}
									</>
								)}
								{showviewvoucher && customviewVouchersButton}
								<span className="mt-2 flex items-center justify-end gap-1 font-bold">
									{isOpen ? (
										<ChevronUpIcon className="h-5 w-5 text-white sm:h-6 sm:w-6" />
									) : (
										<ChevronDownIcon className="h-5 w-5 text-white sm:h-6 sm:w-6" />
									)}
								</span>
							</div>
						</div>
					)}
					{/* Chevron */}
					{isMobile && (
						<div className="me-1 mr-2 flex gap-1 sm:items-end">
							<>
								<div className="flex justify-end text-end">
									{" "}
									<>
										{showButton &&
											(customButton || (
												<Button
													// text={`${isMobile ? "" : "New Configuration"}`}

													onClick={(e) => {
														e.stopPropagation();
														onNewConfiguration();
													}}
													color="blue"
													icon={ConfigurationsIcon}
													title="New Configuration"
												/>
											))}
									</>
									{showButtonSetup && (
										<>
											{canRebootTerminal && (
												<Button
													// text="Reboot Terminal"
													onClick={(e) => {
														e.stopPropagation();
														rebootStarlink();
													}}
													icon={RebootIcon}
													title="Reboot Terminal"
												/>
											)}
											{canViewActivationProv && (
												<Button
													// text="Configuration setup"
													onClick={(e) => {
														e.stopPropagation();
														onActivateSetup();
													}}
													icon={ConfigurationsIcon}
													title="Configuration setup"
												/>
											)}
										</>
									)}
									{showviewvoucher && customviewVouchersButton}
								</div>
								<span className="flex items-center justify-end">
									{isOpen ? (
										<ChevronUpIcon className="h-5 w-5 text-white sm:h-6 sm:w-6" />
									) : (
										<ChevronDownIcon className="h-5 w-5 text-white sm:h-6 sm:w-6" />
									)}
								</span>
							</>
						</div>
					)}{" "}
				</Accordion.Title>
				{isOpen && (
					<Accordion.Content
						className={`${backroundClass ? "!bg-black" : "!bg-navbar-bg"} divide-transparent text-white ${classCss ? classCss : ""}`}
						style={{
							borderTop: "none",
						}}
					>
						{isOpen && children}
					</Accordion.Content>
				)}
			</Accordion.Panel>
		</Accordion>
	);
};

export default CustomAccordion;
